export default __webpack_public_path__ + "static/media/akthe_CA_10.62358135.png";